const State = require('../helpers.js').State;

module.exports = State({
    plateNo: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    street: '',
    streetNo: ''
});